import { render, staticRenderFns } from "./linkCustom.vue?vue&type=template&id=056b8f91&scoped=true"
import script from "./linkCustom.vue?vue&type=script&lang=js"
export * from "./linkCustom.vue?vue&type=script&lang=js"
import style0 from "./linkCustom.vue?vue&type=style&index=0&id=056b8f91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b8f91",
  null
  
)

export default component.exports